import { render, staticRenderFns } from "./ProjectViewProjectInfoCard.vue?vue&type=template&id=03ba69c1"
import script from "./ProjectViewProjectInfoCard.vue?vue&type=script&lang=js"
export * from "./ProjectViewProjectInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports